import { motion, AnimatePresence } from 'framer-motion';

const backdrop = {
  hidden: { opacity: 0 },
  visible: { opacity: 1 },
};

const modal = {
  hidden: { y: 40, opacity: 0, scale: 0.96 },
  visible: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: { duration: 0.25, ease: 'easeOut' },
  },
};

export default function MotionModal({ open, onClose, children }) {
  if (!open) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center px-2 sm:px-6"
        variants={backdrop}
        initial="hidden"
        animate="visible"
        exit="hidden"
        onClick={onClose}
      >
        <motion.div
          variants={modal}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={e => e.stopPropagation()}
          className="
            bg-white
            w-full
            max-w-6xl          /* 👈 THIS is the key change */
            max-h-[90vh]
            rounded-xl
            shadow-xl
            relative
            overflow-hidden
          "
        >
          {/* close button */}
          <button
            onClick={onClose}
            className="absolute top-5 right-12 text-red-400 hover:text-red-600"
          >
            ✕
          </button>

          {/* scroll container */}
          <div className="p-6 overflow-y-auto max-h-[90vh]">
            {children}
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
